import React from 'react';
import PropTypes from 'prop-types';

import { t } from 'i18next';

import { Box, styled, Typography } from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { Button } from '../../common/Button';

import { styles } from './styles';

const NotFoundRaw = ({ className }) => {
  const navigateRedirect = useNavigate();

  const handleRedirect = () => {
    navigateRedirect('/');
  };

  return (
    <Box className={className}>
      <Box>
        <Typography className="dn-404-text">404</Typography>
        <Box>
          <Button variant="outlined" onClick={handleRedirect} className="dn-button-secondary">
            {t('Back to home page')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

NotFoundRaw.propTypes = {
  className: PropTypes.string,
};

export const NotFoundPage = styled(NotFoundRaw)(styles);
NotFoundPage.propTypes = NotFoundRaw.propTypes;
